
// Menu on Hover
  document.addEventListener('DOMContentLoaded', () => {
    // document.querySelectorAll('.text-room-boxes').forEach(function(box) {
    //   box.addEventListener('click', function(e) {
    //     console.log('text-room-boxes clicked:', this);
      
    //     // your logic here
    //     this.classList.toggle('hover');
    //   });
    // });

    var helpLinkEl = document.querySelector('.help-room-link');
    helpLinkEl.addEventListener('click', function(e) {
      this.parentElement.classList.toggle('hover');
    });

    var genealogistLinkEl = document.querySelector('.genealogist-link');
    genealogistLinkEl.addEventListener('click', function(e) {
      this.parentElement.classList.toggle('hover');
    });

    // document.querySelectorAll('.help-room-link').forEach(function(link) {
    //   link.addEventListener('click', function(e) {
    //   this.classList.toggle('hover');
    //     console.log('after toggle:', this.classList.contains('hover'));
    //   });
    // });


    /*
    var textLinkEl = document.querySelector('.text-room-boxes');
    console.log("textLinkEl", textLinkEl);
    textLinkEl.addEventListener('click', function(e) {
      e.stopPropagation(); // prevents jQuery's .vertical li a handler from ever seeing this click
      this.classList.toggle('hover');
      console.log('after toggle:', this.classList.contains('hover'));
    });
    */ 

    function getActivePreviewContainer() {
      var edit = document.querySelector('.edit_relationship_preview');
      var mayflower = document.querySelector('.mayflower_society_preview');
      return (edit && getComputedStyle(edit).display !== 'none') ? edit : mayflower;
    }

    var activeContainer = getActivePreviewContainer();
    var textLinkEl = activeContainer ? activeContainer.querySelector('.text-room-boxes') : null;
    console.log("textLinkEl", textLinkEl);

    if (!textLinkEl) return;

    textLinkEl.addEventListener('click', function(e) {
      e.stopPropagation(); // prevents jQuery's .vertical li a handler from ever seeing this click
      this.classList.toggle('hover');
      console.log('after toggle:', this.classList.contains('hover'));
    });

    document.querySelectorAll('.text-links-nav li').forEach(function(li) {
      li.addEventListener('click', function(e) {
        var textValue = this.textContent.trim();
        console.log('clicked li text:', textValue);
        

        // your logic here, e.g.:
        // switch(textValue) { ... }
        switch(textValue) { 
          case "Title Textboxes":
            localStorage.currentStep = "Title";
            // $('#text-box-input').removeClass('plaque-textbox');
            // displayWholeSuggestionBtn("title");
            textBox(1);  
            
            break;
          case "Origins Textboxes":
            localStorage.currentStep = "Origins";
            // $('#text-box-input').removeClass('plaque-textbox');
            // displayWholeSuggestionBtn("origins");
            textBox(3);
            break;
          case "Arrival Textboxes":
            localStorage.currentStep = "Arrival";
            // $('#text-box-input').removeClass('plaque-textbox');
            // displayWholeSuggestionBtn("arrival");
            textBox(2);

            break;
          case "ShipInfo Textboxes":
            localStorage.currentStep = "ShipInfo";
            // $('#text-box-input').removeClass('plaque-textbox');
            // displayWholeSuggestionBtn("shipinfo");
            textBox(4);
            
            break;                    
          case "Plaque Textboxes":
            localStorage.currentStep = "Plaque";
            // $('#text-box-input').addClass('plaque-textbox');
            // displayWholeSuggestionBtn("plaque");
            textBox(5);
            
            break;
        }

      });
    });

  });
// Menu on Hover jQuery old
  /*
    $(document).ready(function () {
      // On Hover - Opens Sub menu 
          $('.vertical li').hover( function() {
            $(this).addClass('hover');
            var str = $(this).find('a').eq(0).text();
        
          }, function() {
            $(this).removeClass('hover');
            var str = $(this).find('a').eq(0).text();

          });

    })
  */